import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import {useGetSeriesQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {useRequiredParams} from 'shared/web';

import {DocumentSeriesForm} from './components/DocumentSeriesForm';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('entity.document.labels.seriesTitle'),
    href: settingsRoutes.seriesDefinition,
  },
];

export function SeriesDefinitionEdit() {
  const {id} = useRequiredParams();

  const {
    data: series,
    isLoading,
    isError,
  } = useGetSeriesQuery({seriesId: id}, {refetchOnMountOrArgChange: true});

  const title = i18n.t('entity.documentSeries.actions.updateSeries');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{breadcrumbs, title}}
        data-testid="general-document-series-modal"
        isLoading={isLoading}
        isError={isError}
      >
        <DocumentSeriesForm series={series} />
      </SettingsTemplate>
    </>
  );
}
